module.exports = __webpack_public_path__ + "static/media/project15.31305ce4.png";